<script setup lang="ts">
const props = defineProps<{ dates: Date[] }>();

const date = computed(() => props.dates[0]);
</script>

<template>
  <figure v-if="date">
    <span v-if="dates.length === 1">{{ date.getDate() }}</span>
    <IconsGraphicsStarIcon
      v-else
      aria-hidden="true"
      class="star-icon"
    />
    <span>{{ date.toLocaleDateString("no-NO", { month: "short" }) }}</span>
  </figure>
</template>

<style scoped lang="scss">
figure {
  background-color: white;
  padding: 0.5rem 1rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 1rem;
  gap: -3rem;
  max-width: fit-content;

  @media screen and (min-width: $extra-small) {
    min-width: 7rem;
  }

  span:first-child {
    font-size: 2rem;

    @media screen and (min-width: $extra-small) {
      font-size: 4rem;
    }
  }

  span:last-child {
    font-size: 1.2rem;
    text-transform: uppercase;
  }

  .star-icon {
    transform: scale(1.3);
    margin: 1rem 0;
  }
}
</style>
